export default theme => ({
  root: {
    padding: 10
  }
});
